import * as yup from 'yup';
import { sharedDinamisFields } from '../shared/sharedDinamisSchema';

export const carDinamisSchemaBuilder = (
  firstDriverAdditionalPremiumAge,
  secondDriverAdditionalPremiumAge,
  firstDriverAdditionalPremiumLicenseYears,
  secondDriverAdditionalPremiumLicenseYears,
  legalEntity,
  secondDriver,
  discountEntity,
  vehicleType
) => {
  return yup.object({
    ...sharedDinamisFields(
      firstDriverAdditionalPremiumAge,
      secondDriverAdditionalPremiumAge,
      firstDriverAdditionalPremiumLicenseYears,
      secondDriverAdditionalPremiumLicenseYears,
      legalEntity,
      secondDriver,
      discountEntity,
      vehicleType
    ),
    color: yup.string().required(),
  });
};

export default carDinamisSchemaBuilder;
